<template>
  <div class="content_con">
    <p class="text-center" style="margin-bottom: 20px">
      <span class="title">关于东进公司2025年度PCO管理顾问咨询项目的遴选通知</span>
    </p>
    <p class="content heading">各服务公司：</p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"
        >广东东进有害生物防控技术有限公司（简称“东进公司”）拟开展东进公司2025年度PCO管理顾问咨询项目（项目名称），该项目的专业性较强，根据工作需要，拟对外委托专业咨询服务公司开展2025年度PCO管理顾问咨询项目服务工作，本次采购以遴选的方式开展。现将相关情况介绍如下：</span
      >
    </p>
    <p class="text-left text-indent-37 line-height-39 content">
      一、<span class="heading">项目概况</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"
        >广东东进有害生物防控技术有限公司是东莞市人民政府国有资产监督委员会下属重点国企--东莞实业投资控股集团有限公司旗下全资子公司广东东鸿物业发展有限公司的实际控制企业，也是市属重点国企--东莞港务集团有限公司旗下全资子公司东莞港湾区快线集团的参股企业，同时也是全国唯一的专业针对有害生物防控防治的国有性质企业。持国家、省、市有害生物防制服务能力<span
          class="content heading"
          >A（甲）级资质</span
        >。
        随着公司业务量的增加，业务范围已遍及东莞、深圳、惠州、韶关、中山、广州、四川、江苏等区域。专业为海关各口岸、东莞健康驿站、<span
          class="content heading"
          >世界500强企业</span
        >、在粤企事业、机关单位和南部战区各基层部队提供有害生物防控防制、消毒防疫及空气治理、集中空调通风系统清洗等服务，在行业获得较高的声誉和良好口碑。</span
      >
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"
        >东进公司在经历承接业务扩张、业态多样化后，急需提升企业管理水平，提升市场竞争力，从而驱动东进公司可持续健康发展、助力十四五战略目标的实现和稳步发展。</span
      >
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"
        >东进公司<span class="content heading">PCO</span
        >管理顾问咨询的基本要求（本项目）如下：</span
      >
    </p>

    <p class="text-indent-37 line-height-39 text-autospace">
      <span class="number">（1）</span>
      <span class="content"
        >根据东进公司的有害生物防制发展方向及实际需求计划，协助企业为政府病媒生物防制、林业有害生物防治、水利堤坝白蚁防治、农业病虫害（含红火蚁）防治、交通运输领域消毒及病虫害（含红火蚁、白蚁）防治项目提供专家委派、培训讲座及现场技术指导，为商业有害生物防治项目提供客户培训及技术指导；
      </span>
    </p>
    <p class="text-indent-37 line-height-39 text-autospace">
      <span class="number">（2）</span>
      <span class="content"
        >根据东进公司内部员工年度培训计划，提供有害生物防制技能培训，策划安排管理人员外部行业交流学习。
      </span>
    </p>
    <p class="text-indent-37 line-height-39 text-autospace">
      <span class="number">（3）</span>
      <span class="content"
        >日常根据东进公司业务需要，协助提供有害生物防制领域的技术咨询、方案支持、招投标辅导、人工智能/信息化管理等顾问咨询服务。
      </span>
    </p>
    <p class="text-indent-37 line-height-39 text-autospace">
      <span class="number">（4）</span>
      <span class="content"
        >根据东进公司实际需要，协助进行企业行业资质或人员技能职称更新辅导工作。/信息化管理等顾问咨询服务。
      </span>
    </p>
    <p class="text-indent-37 line-height-39 text-autospace">
      <span class="number">（5）</span>
      <span class="content"
        >服务期：<span class="content block">1</span
        >年；合同到期后，经采购方综合考核评估后双方协商一致可续签<span
          class="content block"
          >1</span
        >年服务期。/信息化管理等顾问咨询服务。
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39 content">
      二、<span class="heading">中标单位服务内容与要求</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"
        >（一）在<span class="content heading">10</span
        >个工作日以内完成以下需求的参考项目成果：
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"
        >参考提交的项目成果包括但不限于：东进公司<span class="content heading">2025</span
        >年度<span class="content heading">PCO</span
        >管理顾问咨询项目工作方案，并获得东进公司确认方可提供<span class="content heading"
          >PCO</span
        >管理顾问咨询服务。
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"
        >（二）根据东进公司的有害生物防制发展方向及实际需求计划，在年内协助企业完成不低于<span
          class="content heading"
          >1</span
        >次专家委派指导，不低于<span class="content heading">6</span
        >次内、外部培训或技术指导服务，包含不限于客户培训讲座、现场技术指导、人员技能/资质培训、管理人员交流、招投标辅导、企业资质更新辅导及人工智能/信息化管理等。
      </span>
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      三、<span class="heading">供应商资格条件</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"
        >（一）供应商必须是具有独立承担民事责任能力的企业或事业单位法人或其他组织。【提供《营业执照》复印件（加盖公章）或《事业单位法人证书》复印件（加盖公章）或其他主体证书复印件（加盖公章）】。
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">（二）其它要求 </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">本项目不接受联合体投标及涉及外资股权性质企业参与。 </span>
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      四、<span class="heading">年度采购费用预算</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"
        >采购总预算：人民币<span class="content heading">45</span
        >万/年（不含税）；据采购人指派工作内容，据实结算。
      </span>
    </p>

    <el-table :data="workTableData" style="width: 100%" border>
      <el-table-column prop="index" label="序号" width="50" header-align="center" />
      <el-table-column prop="workContent" label="工作内容" header-align="center" />
      <el-table-column prop="unit" label="单位" width="100" header-align="center" />
      <el-table-column prop="price" label="单价（元）" width="100" header-align="center">
        <template slot="header" slot-scope="scope">
          <span style="color: red">
            {{ scope.column.label }}
          </span>
        </template>
        <template slot-scope="scope">
          <span style="color: red">
            {{ scope.row.price }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" header-align="center" />
      <template slot="append">
        <div style="padding: 10px 20px; color: #000; font-weight: 700">
          备注：以上项目根据管理方需求安排或中标方审批计划执行，具体以实际开展项目进行结算，以上单价金额不含税，每季度结算一次。
        </div>
      </template>
    </el-table>

    <p class="text-left text-indent-37 line-height-39 content">
      五、<span class="heading">保证金</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">本项目不用提交保证金。</span>
    </p>
    <p class="text-left text-indent-37 line-height-39 content">
      六、<span class="heading">投标文件组成部分</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> （一）报价函（模板）； </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> （二）法人证明（模板）以及法人身份证复印件； </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> （三）法人授权书（模板）及被委托人身份证复印件；</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> （四）服务商资格文件；</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> （五）服务商同类业绩；</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> （六）项目人员配备情况；</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> （七）项目工作方案等； </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> （八）服务商认为需要提供的其他资料。</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        服务商须严格按照采购人提供的表单格式报价，投标文件必须每页加盖公章并装订、密封完好并于骑缝处加盖投标单位企业公章。装有投标文件的文件袋须贴有密封条，于骑缝处加盖企业公章。</span
      >
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      七、<span class="heading">遴选程序</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        （一）有意向的服务单位请将投标文件一式五份，含正本<span class="content heading"
          >1</span
        >份、副本<span class="content heading">4</span
        >份，正本必须为盖章原件，副本可为正本的复印件，并提供盖章版<span
          class="content heading"
          >PDF</span
        >扫描电子文件（U盘），于<span class="red_text">2025年3月14日</span
        >携密封的投标文件到下列地址参与开标：</span
      >
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        递交投标文件时间：<span class="red_text"
          >2025年3月14日（北京时间）9:00～9:30</span
        >
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        投标文件截止及开标时间<span class="red_text">2025年3月14日9:30</span>
      </span>
    </p>

    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        开标地点：广东省东莞市南城街道中天商业街<span class="content heading">28</span
        >号<span class="content heading">1</span>栋<span class="content heading">214</span
        >室</span
      >
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        联系人：张小姐 &nbsp;&nbsp;&nbsp;
        <span class="content heading">13929490394</span></span
      >
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> （二）遴选评审标准：</span>
    </p>
    <el-table :data="contactData" style="width: 100%" border>
      <el-table-column prop="index" label="序号" width="50" header-align="center" />
      <el-table-column prop="evaluationItem" label="评审项目" header-align="center">
        <template slot-scope="scope">
          <span v-html="scope.row.evaluationItem"></span>
        </template>
      </el-table-column>
      <el-table-column prop="score" label="分值" width="100" header-align="center" />
    </el-table>

    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        （三）由采购人组织招投标专家或内部相关管理人员进行评审，供应商存在与采购人同类业务开展情况的，采购人可以直接拒绝评审，按废标处理。</span
      >
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        （四）采购人组建的遴选工作小组内部对各供应商的投标方案进行评议，推荐综合评议排名第一者为成交候选人，并按规定的程序进行报批。</span
      >
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        （五）供应商所提交的信息资料的真实性及完整性负责，一旦发现存在造假现象将取消中标资格，三年内不得参与采购人组织的采购活动。</span
      >
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> （六）有效投标人少于3家的，本项目采购失败。</span>
    </p>

    <p class="text-right text-indent-37 line-height-39">
      <span class="content"> 采购人：广东东进有害生物防控技术有限公司</span>
    </p>
    <p class="text-right text-indent-37 line-height-39">
      <span class="content"> 2025年03月05日</span>
    </p>

    <p class="file-link-box">
      <a
        class="group1 cboxElement"
        href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_doc.gif"
        title=""
        ><img
          class="icon"
          src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_doc.gif" /></a
      ><a
        class="file-link"
        href="/20250306/关于东进公司2025年度PCO管理顾问咨询项目的遴选通知.doc"
        title="关于东进公司2025年度PCO管理顾问咨询项目的遴选通知.doc"
        >关于东进公司2025年度PCO管理顾问咨询项目的遴选通知.doc</a
      >
    </p>
    <p class="file-link-box">
      <a
        class="group1 cboxElement"
        href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"
        title=""
        ><img
          class="icon"
          src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif" /></a
      ><a
        class="file-link"
        href="/20250306/关于东进公司2025年度PCO管理顾问咨询项目的遴选通知.pdf"
        title="关于东进公司2025年度PCO管理顾问咨询项目的遴选通知.pdf"
        >关于东进公司2025年度PCO管理顾问咨询项目的遴选通知.pdf</a
      >
    </p>
  </div>
</template>
<script>
export default {
  name: "DocDisplay",
  data() {
    return {
      workTableData: [
        {
          index: 1,
          workContent: "一线员工技能/专业素质提升培训",
          unit: "人/次",
          price: "6000.00",
          remark: "不少于三个小时",
        },
        {
          index: 2,
          workContent: "广东省内范围管理人员学习交流",
          unit: "人/次",
          price: "2000.00",
          remark: "不少于半天",
        },
        {
          index: 3,
          workContent: "组织参加国家级行业协会交流活动",
          unit: "人/次",
          price: "10000.00",
          remark: "不少于一天",
        },
        {
          index: 4,
          workContent: "组织参加广东省行业协会交流活动",
          unit: "人/次",
          price: "6000.00",
          remark: "不少于一天",
        },
        {
          index: 5,
          workContent: "组织参加东莞市行业协会交流活动",
          unit: "人/次",
          price: "3000.00",
          remark: "不少于半天",
        },
        {
          index: 6,
          workContent:
            "委派行业专家对卫健/爱卫系统、林业系统、农业系统、水利系统、教育系统、交通运输系统专题讲座。",
          unit: "人/次",
          price: "15000.00",
          remark: "不少于2个小时或根据客户单位要求进行",
        },
        {
          index: 8,
          workContent:
            "卫健/爱卫系统、林业系统、农业系统、水利系统、教育系统、交通运输系统项目技术培训指导。",
          unit: "人/次",
          price: "6000.00",
          remark: "不少于2个小时或根据客户单位要求进行",
        },
        {
          index: 10,
          workContent: "商业客户项目现场技术指导",
          unit: "人/次",
          price: "5000.00",
          remark: "不少于半天",
        },
        {
          index: 11,
          workContent: "重点客户培训/相关单位讲座",
          unit: "人/次",
          price: "6000.00",
          remark: "不少于2个小时",
        },
        {
          index: 12,
          workContent: "人工智能/信息化管理支持",
          unit: "人/次",
          price: "3000.00",
          remark: "不少于半天",
        },
        {
          index: 13,
          workContent: "招投标辅导/线上咨询支持",
          unit: "人/次",
          price: "2500.00",
          remark: "不少于2个小时",
        },
        {
          index: 14,
          workContent: "相关职业资格培训证书申报（初级）",
          unit: "人",
          price: "4000.00",
          remark: "",
        },
        {
          index: 15,
          workContent: "相关职业资格培训证书申报（中级）",
          unit: "人",
          price: "6000.00",
          remark: "",
        },
        {
          index: 16,
          workContent: "相关职业资格培训证书申报（高级）",
          unit: "人",
          price: "8000.00",
          remark: "",
        },
        {
          index: 17,
          workContent: "相关职业资格培训证书申报（二级技师）",
          unit: "人",
          price: "10000.00",
          remark: "",
        },
        {
          index: 18,
          workContent: "相关职业资格培训证书申报（一级技师）",
          unit: "人",
          price: "12000.00",
          remark: "",
        },
        {
          index: 19,
          workContent: "市场调研报告/可行性报告/资质辅导资料",
          unit: "次",
          price: "5000.00",
          remark: "",
        },
        {
          index: 20,
          workContent: "市级企业消杀、清洁行业资质辅导",
          unit: "次",
          price: "15000.00",
          remark: "不少于2天",
        },
        {
          index: 21,
          workContent: "省级企业消杀、林业行业资质辅导",
          unit: "次",
          price: "30000.00",
          remark: "不少于3天",
        },
        {
          index: 22,
          workContent: "国家级企业消杀行业资质辅导",
          unit: "次",
          price: "50000.00",
          remark: "不少于5天",
        },
      ],
      contactData: [
        {
          index: 1,
          evaluationItem:
            "投标人具备有害生物防制协会颁发的A级（甲）资质证书，国家级得10分，省级得5分，市级得2分，不提供不得分。（提供投标人有效资质证书复印件及加盖投标人公章）",
          score: 10,
        },
        {
          index: 2,
          evaluationItem:
            "拟投入项目负责人具备有害生物防制协会聘请专家或教授讲师的，国家级得10分，省级得5分，市级得2分，不提供不得分。（提供项目负责人有效聘书复印件及加盖投标人公章）",
          score: 10,
        },
        {
          index: 3,
          evaluationItem:
            "根据投标人的响应时间（以到达采购人注册地：广东省东莞市南城街道中天商业街28号1栋209室）进行评审：<br/>（1）投标人接到采购人通知后，承诺1小时（含）内到达的，得10分；<br/>（2）投标人接到采购人通知后，承诺2小时（含）内到达的，得5分；<br/>（3）投标人接到采购人通知后，承诺3小时（含）内到达的，得1分；<br/>（4）其它情况不得分。<br/>注：须提供投标人到达采购人注册地址的导航路线截图（以导航截图为准）及提供服务承诺书，以上资料加盖投标人公章。",
          score: 10,
        },
        {
          index: 4,
          evaluationItem:
            "具有同类项目的顾问咨询或培训服务经验，每提供一个合同得2分，最高得10分。（提供有效合同复印件及加盖投标人公章）",
          score: 10,
        },
        {
          index: 5,
          evaluationItem:
            "对整体服务工作方案进行评议。方案全面、详尽、优越得得20分，方案满足、一般的得5-10分，方案简单、较差的得1-3分。",
          score: 20,
        },
        {
          index: 6,
          evaluationItem: "现场答疑情况进行评议，优秀的得10分，良好得5分，一般的得2分。",
          score: 10,
        },
        {
          index: 7,
          evaluationItem:
            "本项目进行2轮报价，每轮报价高于前一轮报价的均按无效报价处理。综合评分法中的价格分统一采用低价优先法计算，即满足遴选文件要求且最后报价最低的服务商（响应人）的价格为遴选基准价，其价格分为满分。其他服务商（响应人）的价格分统一按照下列公式计算：<br/>投标报价得分 =（评标基准价/投标报价）×价格权值（30%）×100<br/>说明：评分计算最终保留两位小数（第三位四舍五入），偏差率不足1%时， 按比例计算。",
          score: 30,
        },
        { index: "合计", evaluationItem: "", score: 100 },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.content_con {
  font-size: 14px;
  font-family: "宋体", Arial;
  padding: 0px 50px;
  color: #515050;

  a {
    text-decoration: none;
    color: inherit;
  }

  .fa {
    color: #333;
    font-size: 12px;
  }

  .line-height-2em {
    line-height: 2em;
  }

  .text-center {
    text-align: center;
  }

  .margin-bottom-21 {
    margin-bottom: 21px;
  }

  .title {
    font-size: 27px;
    font-family: 方正小标宋简体;
  }

  .text-indent-37 {
    text-indent: 37px;
  }

  .line-height-39 {
    line-height: 39px;
  }

  .content {
    font-weight: 200;
    font-size: 19px;
    font-family: 仿宋_GB2312;
  }

  .heading {
    font-size: 19px;
    font-family: 黑体;
  }

  .block {
    font-family: 黑体;
    color: #000;
    font-weight: 700;
  }

  .red_text {
    color: red;
  }

  .number {
    font-size: 19px;
    font-family: "Times New Roman", "serif";
  }

  .underline {
    text-decoration: underline;
  }

  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }

  .text-autospace {
    margin: 3px;
    padding: 3px;

    span {
      color: #515050;
      font-size: 14px !important;
    }
  }

  .icon {
    vertical-align: middle;
    margin-right: 2px;
  }

  .file-link-box {
    margin: 3px;
    padding: 3px;
    font-size: 14px;
    text-indent: 22px;
    line-height: 16px;
  }

  .file-link {
    font-size: 12px;
    color: #0066cc;
  }
}
</style>
